import { lazy } from "react";


// use lazy for better code splitting, a.k.a. load faster
const HomePage = lazy(() => import("../pages/home/Home"));
const SignupPage = lazy(() => import("../pages/auth/SignUp"));
const SigninPage = lazy(() => import("../pages/auth/SignIn"));
const ForgotPasswordPage = lazy(() => import("../pages/auth/ForgetPassword"));
const ResetPasswordPage = lazy(() => import("../pages/auth/ResetPassword"));
const ChangePasswordPage = lazy(() => import("../pages/auth/ChangePassword"));
const KycPage = lazy(() => import("../pages/auth/kyc/KycProfileCompletion"));

const StudyInFinnishPage = lazy(() => import("../pages/studyInFinnish/StudyInFinnish"));
const EasyGoEduPage = lazy(() => import("../pages/studyInFinnish/easyGoEdu/EasyGoEdu"));

const StudyInEnglishPage = lazy(() => import("../pages/studyInEnglish/StudyInEnglish"));
const StudyInUkAndCanadaPage = lazy(() => import("../pages/studyInUkAndCanada/StudyInUkAndCanada"));

const AboutUsPage = lazy(() => import("../pages/aboutUs/AboutUs"));
const GalleryPage = lazy(() => import("../pages/gallery/Gallery"));
const ConsultationPage = lazy(() => import("../pages/consultation/Consultation"));
const ContactUsPage = lazy(() => import("../pages/contactUs/ContactUs"));
const FaqPage = lazy(() => import("../pages/faq/FaqPage"));
const TestimonialPage = lazy(() => import("../pages/testimonials/TestimonialsPage"));
const BecomeAnAgentPage = lazy(() => import("../pages/becomeAnAgent/BecomeAnAgent"));
const TermsAndConditionPage = lazy(() => import("../pages/termsAndCondition/TermsAndCondition"));

const PsychometricTestPage = lazy(() => import("../pages/psychometricTest/PsychometricTestHome"));
const PsychometricTestProgramsPage = lazy(() => import("../pages/psychometricTest/PsychometricTestPrograms"));
const PsychometricTestGenInfo = lazy(() => import("../pages/psychometricTest/components/PsychometricTestGenInfo"));
const PsychometricTestBachelorPage = lazy(() => import("../pages/psychometricTest/PsychometricTestBachelor"));
const PsychometricTestBachelorQuestionsPage = lazy(() => import("../pages/psychometricTest/PsychoBachelorQuestions"));
const PsychometricTestQuestionsPage = lazy(() => import("../pages/psychometricTest/components/PsychometricQuestions"));
const PsychometricTestMastersPage = lazy(() => import("../pages/psychometricTest/PsychometricTestMasters"));
const PsychometricTestMastersQuestionsPage = lazy(() => import("../pages/psychometricTest/PsychoMastersQuestions"));
const PsychometricTestPhdPage = lazy(() => import("../pages/psychometricTest/PsychometricTestPhd"));
const PsychometricTestPhdQuestionsPage = lazy(() => import("../pages/psychometricTest/PsychoPhdQuestions"));
const PsychometricTestListOfProgramsPage = lazy(() => import("../pages/psychometricTest/ListOfPrograms"));

const BlogPage = lazy(() => import("../pages/blog/Blog"));
const WaecAndJambPage = lazy(() => import("../pages/waecAndJamb/WaecAndJamb"));
const WaecAndJambStartPage = lazy(() => import("../pages/waecAndJamb/WaecStart"));
const BlogDetailPage = lazy(() => import("../pages/blog/BlogDetail"));

const ExploreProgramsPage = lazy(() => import("../pages/explorePrograms/ExplorePrograms"));
const ProgramOverviewPage = lazy(() => import("../pages/explorePrograms/ProgramOverview"));
const AppSummaryPage = lazy(() => import("../pages/explorePrograms/AppSummary"));
const DegreeApplicationFormPage = lazy(() => import("../pages/explorePrograms/DegreeApplicationForm"));
const LithuaniaApplicationFormPage = lazy(() => import("../pages/explorePrograms/LithuaniaApplicationForm"));
const MastersApplicationFormPage = lazy(() => import("../pages/explorePrograms/MastersApplicationForm"));
const DiplomaApplicationFormPage = lazy(() => import("../pages/explorePrograms/DiplomaApplicationForm"));
const RestaurantAndCateringApplicationFormPage = lazy(() => import("../pages/explorePrograms/RestaurantCateringForm"));
const TourismAndHospitalityApplicationFormPage = lazy(() => import("../pages/explorePrograms/TourismAndHospitalityManagementForm"));
const CanadaApplicationFormPage = lazy(() => import("../pages/explorePrograms/CanadaApplicationForm"));
const UkApplicationFormPage = lazy(() => import("../pages/explorePrograms/UkApplicationForm"));


const LoanHomePage = lazy(() => import("../pages/loan/LoanHome"));
const EduSilverPage = lazy(() => import("../pages/loan/EduSilver"));
const EduGoldPage = lazy(() => import("../pages/loan/eduGold/EduGold"));
const EduPremiumPage = lazy(() => import("../pages/loan/eduPremium/EduPremium"));
const EduPremiumSchoolProcessingPage = lazy(() => import("../pages/loan/eduPremium/PremiumSchoolProcessing"));
const EduPremiumLoanProcessingPage = lazy(() => import("../pages/loan/eduPremium/PremumLoanProcessing"));
const VerifyEmailPage = lazy(() => import("../pages/auth/VerifyEmail"));
const VerifyEmailSuccessPage = lazy(() => import("../pages/auth/VerifyEmailSuccess"));
const ResidentPermitPage = lazy(() => import("../pages/residentPermit/ResidentPermitPage"));
const ResidentPermitCartPage = lazy(() => import("../pages/residentPermit/CartPage"));
const ResidentPermitCheckoutPage = lazy(() => import("../pages/residentPermit/CheckoutPage"));

// admin dashboard
const VerifyPasswordPage = lazy(() => import("../pages/auth/VerifyPassword"));
const AdminDashboardPage = lazy(() => import("../pages/adminDashboard/home/Home"));
const AdminDashboardCoursePage = lazy(() => import("../pages/adminDashboard/courseAndPrograms/CourseAnPrograms"));
const AdminDashboardApplicationsPage = lazy(() => import("../pages/adminDashboard/applications/Applications"));
const AdminDashboardUploadCoursePage = lazy(() => import("../pages/adminDashboard/courseAndPrograms/UploadCourse"));
const AdminDashboardEditCoursePage = lazy(() => import("../pages/adminDashboard/courseAndPrograms/EditCourse"));
const AdminDashboardManagementPage = lazy(() => import("../pages/adminDashboard/adminManagement/AdminManagement"));
const AdminDashboardUserPage = lazy(() => import("../pages/adminDashboard/userManagement/UserManagemnt"));
const AdminDashboardUserDetailsPage = lazy(() => import("../pages/adminDashboard/userManagement/UserDetails"));
const AdminDashboardBlogPage = lazy(() => import("../pages/adminDashboard/blog/Blog"));
const AdminDashboardTestimonialPage = lazy(() => import("../pages/adminDashboard/testimonials/Testimonials"));
const AdminDashboardBannerPage = lazy(() => import("../pages/adminDashboard/banner/Banner"));
const AdminDashboardPsychometricTestPage = lazy(() => import("../pages/adminDashboard/psychometricTestAdmin/PsychometricTestAdmin"));
const AdminDashboardPsychometricTestCoursePage = lazy(() => import("../pages/adminDashboard/psychometricTestCourseAdmin/PsychometricTestCourseHome"));
const AdminDashboardAddPsychometricTestCoursePage = lazy(() => import("../pages/adminDashboard/psychometricTestCourseAdmin/PsychometricTestCourseAdmin"));
const AdminDashboardEditPsychometricTestCoursePage = lazy(() => import("../pages/adminDashboard/psychometricTestCourseAdmin/EditPsychometricTestCourse"));
const AdminDashboardLoanApplicationPage = lazy(() => import("../pages/adminDashboard/loanApplication/LoanApplication"));
const AdminDashboardPaymentPage = lazy(() => import("../pages/adminDashboard/payment/Payment"));
const AdminDashboardWaecAndJambPage = lazy(() => import("../pages/adminDashboard/waecAndJamb/WaecAndJamb"));
const AdminDashboardFaqManagementPage = lazy(() => import("../pages/adminDashboard/faqManagement/FaqManagement"));
const AdminDashboardBecomeAnAgentPage = lazy(() => import("../pages/adminDashboard/becomeAnAgent/BecomeAnAgent"));
const AdminDashboardViewAgentPage = lazy(() => import("../pages/adminDashboard/becomeAnAgent/AgentDetails"));
const AdminDashboardConsultationBookingPage = lazy(() => import("../pages/adminDashboard/consultationBooking/ConsultationBooking"));
const AdminDashboardNotificationPage = lazy(() => import("../pages/adminDashboard/notification/Notification"));
const AdminDashboardContactUsPage = lazy(() => import("../pages/adminDashboard/contactUsInfo/ContactUsInfo"));

// user dashboard
const UserDashboardHomePage = lazy(() => import("../pages/userDashboard/dashboardHome/Dashboard"));
const UserDashboardExploreCoursesHomePage = lazy(() => import("../pages/userDashboard/dashboardHome/UserExploreCourses/UserExploreCourses"));
const UserDashboardProfilePage = lazy(() => import("../pages/userDashboard/profile/Profile"));
const UserDashboardApplicationsPage = lazy(() => import("../pages/userDashboard/appications/Applications"));
const UserDashboardUpskillPage = lazy(() => import("../pages/userDashboard/upskill/Upskill"));
const UserDashboardResidentPermitPage = lazy(() => import("../pages/userDashboard/resident-permit/ResidentPermit"));
const UserDashboardSettingsProfilePage = lazy(() => import("../pages/userDashboard/settings/profileSettings/ProfileSettings"));
const UserDashboardNotificationPage = lazy(() => import("../pages/userDashboard/settings/notification/Notification"));

// agent dashboard
const AgentWelcomePage = lazy(() => import("../pages/agentDashboard/welcome/Welcome"));
const AgentDashboardPage = lazy(() => import("../pages/agentDashboard/dashboard/Dashboard"));
const AgentStudentPage = lazy(() => import("../pages/agentDashboard/students/Dashboard"));
const AgentProfilePage = lazy(() => import("../pages/agentDashboard/profile/Profile"));
const AgentReferralPage = lazy(() => import("../pages/agentDashboard/referrals/Referrals"));
const AgentCommissions = lazy(() => import("../pages/agentDashboard/commissions/Commissions"));
const AgentLatestUpdatePage = lazy(() => import("../pages/agentDashboard/latestUpdates/LatestUpdate"));
const AgentNotificationPage = lazy(() => import("../pages/agentDashboard/notification/Notification"));
const AgentProfileSettingsPage = lazy(() => import("../pages/agentDashboard/settings/profileSettings/ProfileSettings"));
const AgentPayoutSetailsPage = lazy(() => import("../pages/agentDashboard/settings/payoutDetails/PayoutDetails"));
const AgentNotificationPreferencePage = lazy(() => import("../pages/agentDashboard/settings/notificationPreferences/NotificationPreferences"));
const AgentSecurityPage = lazy(() => import("../pages/agentDashboard/settings/security/Security"));

const routes = [
  {
    path: "/",
    component: HomePage,
  },
  {
    path: "/home",
    component: HomePage,
  },
  {
    path: "/sign-up",
    component: SignupPage,
  },
  {
    path: "/forgot-password",
    component: ForgotPasswordPage,
  },
  {
    path: "/reset-password",
    component: ResetPasswordPage,
  },
  {
    path: "/change-password",
    component: ChangePasswordPage,
  },

  {
    path: "/verify-email",
    component: VerifyEmailPage,
  },
  
  {
    path: "/auth/verify-email",
    component: VerifyEmailSuccessPage,
  },
  {
    path: "/verify",
    component: VerifyPasswordPage,
  },
  {
    path: "/kyc",
    component: KycPage,
  },
  {
    path: "/sign-in",
    component: SigninPage,
  },
   {
    path: "/study-in-finnish",
    component: StudyInFinnishPage,
  },
    {
    path: "/study-in-english",
    component: StudyInEnglishPage,
  },
     {
    path: "/study-in-uk-and-canada",
    component: StudyInUkAndCanadaPage,
  },
     {
    path: "/easygoedu-with-afriproedu",
    component: EasyGoEduPage,
  },
     {
    path: "/about-us",
    component: AboutUsPage,
  },
    {
    path: "/gallery",
    component: GalleryPage,
  },
      {
    path: "/consultation",
    component: ConsultationPage,
  },
    {
    path: "/contact-us",
    component: ContactUsPage,
  },
  {
    path: "/faq",
    component: FaqPage,
  },
    {
    path: "/testimonial",
    component: TestimonialPage,
  },
    {
    path: "/become-agent",
    component: BecomeAnAgentPage,
  },
   {
    path: "/terms-condition",
    component: TermsAndConditionPage,
  },
  {
    path: "/psychometric-test",
    component: PsychometricTestPage,
  },
  {
    path: "/blog",
    component: BlogPage,
  },
  {
    path: "/blog-detail/:blog",
    component: BlogDetailPage,
  },
  {
    path: "/psychometric-test/programs",
    component: PsychometricTestProgramsPage,
  },
    {
    path: "/psychometric-test/info",
    component: PsychometricTestGenInfo,
  },
   {
    path: "/psychometric-test/questions",
    component: PsychometricTestQuestionsPage,
  },
  {
    path: "/psychometric-test/bsc",
    component: PsychometricTestBachelorPage,
  },
  {
    path: "/psychometric-test/bachelors/questions",
    component: PsychometricTestBachelorQuestionsPage,
  },
  {
    path: "/psychometric-test/masters",
    component: PsychometricTestMastersPage,
  },
  {
    path: "/psychometric-test/masters/questions",
    component: PsychometricTestMastersQuestionsPage,
  },
  {
    path: "/psychometric-test/phd",
    component: PsychometricTestPhdPage,
  },
  {
    path: "/psychometric-test/phd/questions",
    component: PsychometricTestPhdQuestionsPage,
  },
  {
    path: "/psychometric-test/list-of-programs",
    component: PsychometricTestListOfProgramsPage,
  },
  {
    path: "/explore-programs",
    component: ExploreProgramsPage,
  },
  {
    path: "/program-overview/:id",
    component: ProgramOverviewPage,
  },
  {
    path: "/application-summary/:id",
    component: AppSummaryPage,
  },

    {
    path: "/degree-application-form/:course",
    component: DegreeApplicationFormPage,
  },

  {
    path: "/lithuania-application-form/:course",
    component: LithuaniaApplicationFormPage,
  },
    {
    path: "/masters-application-form/:course",
    component: MastersApplicationFormPage,
  },
      {
    path: "/diploma-application-form/:course",
    component: DiplomaApplicationFormPage,
  },
     {
    path: "/vocational-application-form/:course",
    component: RestaurantAndCateringApplicationFormPage,
  },
    {
    path: "/tourism-and-hospitality-management-form/:course",
    component: TourismAndHospitalityApplicationFormPage,
  },
      {
    path: "/canada-application-form/:course",
    component: CanadaApplicationFormPage,
  },
        {
    path: "/uk-application-form/:course",
    component: UkApplicationFormPage,
  },
  {
    path: "/loan",
    component: LoanHomePage,
  },
  
  {
    path: "/resident-permit",
    component: ResidentPermitPage,
  },
  {
    path: "/resident-permit/cart",
    component: ResidentPermitCartPage,
  },
  {
    path: "/resident-permit/checkout",
    component: ResidentPermitCheckoutPage,
  },
  {
    path: "/loan/edu-silver",
    component: EduSilverPage,
  },
  {
    path: "/loan/edu-gold",
    component: EduGoldPage,
  },
  {
    path: "/loan/edu-premium",
    component: EduPremiumPage,
  },
  {
    path: "/loan/school-processing",
    component: EduPremiumSchoolProcessingPage,
  },
  {
    path: "/loan/loan-processing",
    component: EduPremiumLoanProcessingPage,
  },
  {
    path: "/waec-and-jamb",
    component: WaecAndJambPage,
  },
  {
    path: "/waec-and-jamb/start",
    component: WaecAndJambStartPage,
  },
  {
    path: "/admin/overview",
    component: AdminDashboardPage,
  },
  {
    path: "/admin/courses",
    component: AdminDashboardCoursePage,
  },
    {
    path: "/admin/applications",
    component: AdminDashboardApplicationsPage,
  },
  {
    path: "/admin/courses/upload-course",
    component: AdminDashboardUploadCoursePage,
  },
  {
    path: "/admin/courses/edit/:id",
    component: AdminDashboardEditCoursePage,
  },
  {
    path: "/admin/admin-management",
    component: AdminDashboardManagementPage,
  },
  {
    path: "/admin/user-management",
    component: AdminDashboardUserPage,
  },
  
  {
    path: "/admin/user-management/user-details/:id",
    component: AdminDashboardUserDetailsPage,
  },
  {
    path: "/admin/blog",
    component: AdminDashboardBlogPage,
  },
  {
    path: "/admin/testimonial",
    component: AdminDashboardTestimonialPage,
  },
  {
    path: "/admin/banner",
    component: AdminDashboardBannerPage,
  },
  {
    path: "/admin/psychometric-test",
    component: AdminDashboardPsychometricTestPage,
  },
    {
    path: "/admin/psychometric-test-course",
    component: AdminDashboardPsychometricTestCoursePage,
  },
     {
    path: "admin/psychometric-courses/create",
    component: AdminDashboardAddPsychometricTestCoursePage,
  },
       {
    path: "/admin/psychometric-courses/edit/:id",
    component: AdminDashboardEditPsychometricTestCoursePage,
  },
  {
    path: "/admin/loan-application",
    component: AdminDashboardLoanApplicationPage,
  },
  {
    path: "/admin/payment",
    component: AdminDashboardPaymentPage,
  },
  {
    path: "/admin/waec-and-jamb",
    component: AdminDashboardWaecAndJambPage,
  },
  {
    path: "/admin/faq-management",
    component: AdminDashboardFaqManagementPage,
  },
  {
    path: "/admin/become-an-agent",
    component: AdminDashboardBecomeAnAgentPage,
  },
  
  {
    path: "/admin/become-an-agent/agent-details/:id",
    component: AdminDashboardViewAgentPage,
  },
  {
    path: "/admin/consultation-booking",
    component: AdminDashboardConsultationBookingPage,
  },
    {
    path: "/admin/notification",
    component: AdminDashboardNotificationPage,
  },
  {
    path: "/admin/contact-info",
    component: AdminDashboardContactUsPage,
  },
  {
    path: "/user/dashboard",
    component: UserDashboardHomePage,
  },
  {
    path: "/user/dashboard/explore-programs",
    component: UserDashboardExploreCoursesHomePage,
  },
  {
    path: "/user/profile",
    component: UserDashboardProfilePage,
  },

  {
    path: "/user/aplications",
    component: UserDashboardApplicationsPage,
  },

  {
    path: "/user/resident-permit",
    component: UserDashboardResidentPermitPage,
  },

  {
    path: "/user/upskill",
    component: UserDashboardUpskillPage,
  },

    {
    path: "/user/profile-settings",
    component: UserDashboardSettingsProfilePage,
  },
  {
    path: "/user/notification",
    component: UserDashboardNotificationPage,
  },

    {
    path: "/agent/welcome",
    component: AgentWelcomePage,
  },
    {
    path: "/agent/dashboard",
    component: AgentDashboardPage,
  },
      {
    path: "/agent/students",
    component: AgentStudentPage,
  },
      {
    path: "/agent/profile",
    component: AgentProfilePage,
  },
  {
    path: "/agent/referrals",
    component: AgentReferralPage,
  },
  {
    path: "/agent/commissions-rewards",
    component: AgentCommissions,
  },

    {
    path: "/agent/latest-update",
    component: AgentLatestUpdatePage,
  },
      {
    path: "/agent/notifications",
    component: AgentNotificationPage,
  },
        {
    path: "/agent/profile-settings",
    component: AgentProfileSettingsPage,
  },
          {
    path: "/agent/payout-details",
    component: AgentPayoutSetailsPage,
  },
          {
    path: "/agent/notification-preference",
    component: AgentNotificationPreferencePage,
  },
          {
    path: "/agent/security",
    component: AgentSecurityPage,
  },
];


export default routes;
